import { Component } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [RouterLink, MatIconModule, NgIf],
})
export class FooterComponent {
  public currentYear: number = new Date().getFullYear();

  /** Mobile accordions (mobile view only) */
  supportAccordionOpen = false;
  legalAccordionOpen = false;

  toggleSupportAccordion(): void {
    this.supportAccordionOpen = !this.supportAccordionOpen;
  }

  toggleLegalAccordion(): void {
    this.legalAccordionOpen = !this.legalAccordionOpen;
  }
}
